import { css } from '@emotion/core';
import {
  forwardInnerRef,
  InnerRefProps,
  Panel,
  PopoverArrow,
  SlideTransition,
} from 'localmed-core';
import React, { ComponentProps } from 'react';
import theme from '../../../../diTheme/diEmotionTheme';
import type { PanelProps, PopoverPlacement, SlideDirection } from './types';

type Props = PanelProps &
  InnerRefProps & {
    isOpen?: boolean;
    placement?: PopoverPlacement;
    arrowProps?: Object;
    children?: React.ReactNode;
    style?: ComponentProps<'div'>['style'];
  };

function getSlideDirection(placement?: PopoverPlacement): SlideDirection {
  if (placement == null || placement.includes('bottom')) return 'down';
  if (placement.includes('top')) return 'up';
  if (placement.includes('right')) return 'right';
  if (placement.includes('left')) return 'left';
  return 'down';
}

function PopoverPanel({ isOpen, placement, innerRef, arrowProps, children, ...props }: Props) {
  const { backgroundColor }: any = props;
  return (
    <SlideTransition in={isOpen} direction={getSlideDirection(placement)}>
      <Panel
        ref={innerRef}
        elevation={10}
        padding={0}
        zIndex="popover"
        css={css`
          display: inline-flex;
        `}
        {...props}
      >
        {children}
        <PopoverArrow
          {...arrowProps}
          placement={placement || 'auto'}
          color={backgroundColor && theme.colors[backgroundColor]}
        />
      </Panel>
    </SlideTransition>
  );
}

export default forwardInnerRef(PopoverPanel);
